import React from 'react'
import { observer } from 'mobx-react'
import useSettingsManager from '../hooks/use-settings-manager'

function Logo (props) {

  const settings_manager = useSettingsManager()
  const title = settings_manager.getOtherSettings('nassau', 'Nassau')
  const src = settings_manager.getOtherSettings('logo_src', false)

  if (src === '' || src === false) {
    return null
  }

  return (
    <figure className={'logo'}>
      <img src={src} alt={title} title={title}/>
    </figure>
  )
}

export default observer(Logo)